import { Users, Map, Settings, Calculator, FileSpreadsheet, Notebook } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

interface NavigationItem {
  title: string;
  href: string;
  icon: LucideIcon;
  section: 'main' | 'tools';
}

export const navigationConfig: NavigationItem[] = [
  {
    title: 'Customers',
    href: '/customers',
    icon: Users,
    section: 'main'
  },
  {
    title: 'Maps',
    href: '/maps',
    icon: Map,
    section: 'main'
  },
  {
    title: 'Settings',
    href: '/settings',
    icon: Settings,
    section: 'main'
  },
  {
    title: 'Issues',
    href: '/issues',
    icon: Notebook,
    section: 'main'
  },
  {
    title: 'ROI Calculator',
    href: '/roi',
    icon: Calculator,
    section: 'tools'
  },
  {
    title: 'Consultation Calculator',
    href: '/consultation',
    icon: FileSpreadsheet,
    section: 'tools'
  }
]; 